import {Header as FuelHeader, Popover, PopoverButton, PopoverContent, HeaderActionArea} from '@deere/fuel-react';
import {Box, IconButton, Avatar, Divider, Typography, ListItemButton, ListItemIcon, ListItemText} from '@mui/material';
import {AnchorLink} from './AnchorLink';
import {AccountCircleOutlined, ExitToAppOutlined, Home} from '@mui/icons-material';
import {useNavigationItems} from 'hooks/useNavigationItems';
import {FC, useEffect, useState} from 'react';
import {useOktaAuth} from '@okta/okta-react';

const SIGNOUT_URL = 'https://sso.johndeere.com/login/default';

const Header: FC<unknown> = () => {
    const homeIcon = {
        href: '/',
        label: 'Home',
        selected: location.pathname === '/',
        startIcon: <Home/>
    };

    const navigationItems = [homeIcon, ...useNavigationItems()];

    const {
        authState, oktaAuth
    } = useOktaAuth();
    const [userInfo, setUserInfo] = useState<any>(null);

    useEffect(() => {
        if (!authState || !authState.isAuthenticated) {
            // When user isn't authenticated, forget any user info
            setUserInfo(null);
        } else {
            setUserInfo(authState.idToken?.claims);
        }
    }, [authState, oktaAuth]); // Update if authState changes

    return (
        <FuelHeader
            HeaderLogoLinkComponent={AnchorLink}
            // isContained={true}
            logoLink='/'
            navigationItems={navigationItems}
            title='JDU Admin'
            titleLink=''
        >
            <HeaderActionArea>
                <Popover>
                    <PopoverButton
                        aria-label='Account'
                        component={IconButton}
                    ><AccountCircleOutlined/>
                    </PopoverButton>
                    <PopoverContent>
                        <Box minWidth='225px'>
                            <Box
                                alignItems='center'
                                display='flex'
                                p={4}
                            >
                                <Avatar data-fuel-size='small'>{userInfo?.firstName?.charAt(0)}{userInfo?.lastName?.charAt(0)}</Avatar>
                                <Box ml={3}>
                                    <Typography
                                        color='text.secondary'
                                        data-fuel-size={'sm'}
                                        fontWeight='600'
                                    >{userInfo?.firstName} {userInfo?.lastName}</Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Divider/>
                                <ListItemButton
                                    sx={{
                                        pl: 5
                                    }}
                                >
                                    <ListItemIcon>
                                        <ExitToAppOutlined/>
                                    </ListItemIcon>
                                    <ListItemText
                                        onClick={(): void => {
                                            oktaAuth.signOut({
                                                postLogoutRedirectUri: SIGNOUT_URL
                                            });
                                        }}
                                        primary='Sign Out'
                                        primaryTypographyProps={{
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            color: '#333'
                                        }}
                                    />
                                </ListItemButton>
                            </Box>
                        </Box>
                    </PopoverContent>
                </Popover>
            </HeaderActionArea>
        </FuelHeader>
    );
};

export default Header;
